import type { ReactNode } from 'react'
import type { LearningContentItem } from '@services/firebase/learning'
import {
  LearningSentenceRebuildTemplate,
  LearningVocabularyTemplate,
  type LearningTemplateResult,
} from '@features/learning/shared/templates'
import type { LegacySelfStudyTemplateId } from './self-study-template-contract'
import './self-study-native.css'

export interface RegisteredSelfStudyTemplateProps {
  readonly continuePending?: boolean
  readonly continuePendingLabel?: ReactNode
  readonly expectedAnswers?: readonly string[]
  readonly incorrectReviewText?: string | null
  readonly isMobileOrTablet?: boolean
  readonly item: LearningContentItem
  readonly locale: string
  readonly onContinue: (result: LearningTemplateResult) => void
  readonly onResult?: (result: Exclude<LearningTemplateResult, 'skipped'>) => void
  readonly questionContent?: ReactNode
  readonly sourceOwner: string
  readonly template: LegacySelfStudyTemplateId | null
}

export const REGISTERED_SELF_STUDY_TEMPLATE_IDS = ['3', '4', '12'] as const

export function renderRegisteredSelfStudyTemplate({
  continuePending = false,
  continuePendingLabel,
  expectedAnswers = [],
  incorrectReviewText = null,
  isMobileOrTablet = false,
  item,
  locale,
  onContinue,
  onResult,
  questionContent,
  sourceOwner,
  template,
}: RegisteredSelfStudyTemplateProps): ReactNode | null {
  if (template === '3' || template === '4') {
    return (
      <div className="legacySelfStudyRegisteredTemplate">
        {questionContent}
        <LearningSentenceRebuildTemplate
          continuePending={continuePending}
          continuePendingLabel={continuePendingLabel}
          expectedAnswers={expectedAnswers}
          incorrectReviewText={incorrectReviewText}
          isMobileOrTablet={isMobileOrTablet}
          mode={template === '3' ? 'words' : 'letters'}
          onContinue={onContinue}
          onResult={onResult}
          sourceOwner={sourceOwner}
          template={template}
        />
      </div>
    )
  }

  if (template === '12') {
    return (
      <LearningVocabularyTemplate
        continuePending={continuePending}
        continuePendingLabel={continuePendingLabel}
        item={item}
        locale={locale}
        onContinue={onContinue}
        sourceOwner={sourceOwner}
      />
    )
  }

  return null
}
